import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import HintPopup from '../HintPopup';
import touchIcon from './icons/touch.svg';
import { makeStyles } from '@material-ui/core/styles';
import { LoaderStateContext } from '../../ContextProviders/LoaderStateProvider';
import { ConfigurationContext } from '../../ContextProviders/ConfigurationProvider';
import useConfigurationChanges from '../../Hooks/useConfigurationChanges';

const useStyles = makeStyles((theme) => ({
  text: {
    marginRight: 20,
    marginLeft: 20,
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9em',
    },
    width: 280,
    maxWidth: '100%',
  },
}));

const HowToConfigureHint = () => {
  const isLoading = useContext(LoaderStateContext);
  const { t } = useTranslation();
  const classes = useStyles();
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    const closeWhenSthIsClicked = () => {
      document.removeEventListener('click', closeWhenSthIsClicked, true);
      setShow(false);
    };
    document.addEventListener('click', closeWhenSthIsClicked, true);
  }, []);

  const configuration = useContext(ConfigurationContext);
  const { itemIdentifier } = useConfigurationChanges(configuration);
  const hintText = t(`howToConfigureHint.${itemIdentifier}`, '');

  return (
    <HintPopup open={!!hintText && !isLoading && show} onClose={handleClose}>
      <img src={touchIcon} alt="hint icon" />
      <Typography className={classes.text} dangerouslySetInnerHTML={{ __html: hintText }} />
    </HintPopup>
  );
};

export default HowToConfigureHint;
